










import {Vue, Component} from 'vue-property-decorator'
import ConnectWalletModal from '@/components/walletConnection/ConnectWalletModal.vue'
import NavbarWalletSessionDisconnected from '@/components/navbar/NavbarWalletSessionDisconnected.vue'
import NavbarWalletSessionConnected from '@/components/navbar/NavbarWalletSessionConnected.vue'
import {WalletSessionSummary} from '@/model/wallets/types/WalletSessionSummary'
import {TWalletNetwork} from '@/model/wallets/types/WalletNetwork'

@Component({
  components: {
    NavbarWalletSessionDisconnected,
    NavbarWalletSessionConnected,
    ConnectWalletModal,
  },
})
export default class NavbarWalletSession extends Vue {
  get sessions(): WalletSessionSummary[] {
    const state = this.$store.state.walletAdapter

    return (['n3', 'neoX'] as const).flatMap(walletImplementation => {
      const networks: TWalletNetwork[] =
        state.networksInUse[walletImplementation]

      return networks.map(network => ({
        walletImplementation,
        network,
        label: this.implementationLabel(walletImplementation),
        address: this.formatWalletAddress(
          state.sessions[walletImplementation][network]?.address ?? null
        ),
      }))
    })
  }

  get isDisconnected(): boolean {
    return this.sessions.every(session => !session.address)
  }

  private implementationLabel(walletImplementation: 'n3' | 'neoX'): string {
    const key =
      walletImplementation === 'n3'
        ? 'components.NavbarWalletSessionConnectedButton.n3'
        : 'components.NavbarWalletSessionConnectedButton.x'

    return this.$translate(key)
  }

  formatWalletAddress(address: string | null): string | null {
    if (!address || !address.trim()) return null

    const trimmed = address.trim()

    return `${trimmed.slice(0, 5)}...${trimmed.slice(-5)}`
  }
}
